import { Box, SpaceBetween, Link, Spinner } from '@cloudscape-design/components';
import { useNavigate } from 'react-router-dom';
import { DependentsResponse } from '../../services/configs-api';

interface UsedBySectionProps {
  dependentsData: DependentsResponse | undefined;
  isLoading: boolean;
}

/**
 * "Used By" section showing all configurations that reference the current one.
 * Each dependent is a clickable link navigating to its detail view.
 */
export function UsedBySection({ dependentsData, isLoading }: UsedBySectionProps) {
  const navigate = useNavigate();

  if (isLoading) {
    return (
      <div>
        <Box variant="awsui-key-label">Used By</Box>
        <Spinner size="normal" />
      </div>
    );
  }

  if (!dependentsData || dependentsData.count === 0) {
    return (
      <div>
        <Box variant="awsui-key-label">Used By</Box>
        <Box color="text-status-inactive">Not referenced by any other configurations</Box>
      </div>
    );
  }

  return (
    <div>
      <Box variant="awsui-key-label">Used By ({dependentsData.count} configuration{dependentsData.count !== 1 ? 's' : ''})</Box>
      <SpaceBetween size="xs">
        {dependentsData.dependents.map((dep) => (
          <div key={dep.configId}>
            <Link onFollow={(e) => { e.preventDefault(); navigate(`/configs/${dep.configId}`); }}>
              {dep.configName}
            </Link>
            <Box variant="small" color="text-body-secondary" display="inline"> ({dep.configType})</Box>
          </div>
        ))}
      </SpaceBetween>
    </div>
  );
}
